import clone from 'lodash/clone';
import { config } from 'config';
import i18n from 'i18nextInstance';
import isEmpty from 'lodash/isEmpty';
import optionServices from './services';
import orderBy from 'lodash/orderBy';
import { push } from 'react-router-redux';
import {
    call,
    put,
    select,
    takeEvery
} from 'redux-saga/effects';
import {
    optionActions,
    parseControl,
    parseControls,
    parsePatients,
    parseProfessionals,
    parseRiskAgent,
    parseSpecialties,
    parseWorkplaces
} from './';
import {
    parseSelect,
    replaceObjectArray
} from 'shared/utils';
const { availableLanguages } = config;

function* _createPolyOffice ({ payload }) {
    try {
        yield put(optionActions.setOptionPolyOfficesLoading(true));
        const { data: newPolyOffice } = yield call(optionServices.postPolyOffice, null, payload);
        const { option: { polyOffices } } = yield select();
        yield put(optionActions.setOptionPolyOffices(orderBy([...polyOffices, newPolyOffice]), 'name'));
    } catch (e) {

    } finally {
        yield put(optionActions.setOptionPolyOfficesLoading(false));
    }
}

function* _createSpecialty ({ payload }) {
    try {
        yield put(optionActions.setOptionSpecialtiesLoading(true));
        const { data } = yield call(optionServices.postSpecialty, null, payload);
        yield put(optionActions.setOptionSpecialtiesSuccess(true));
        const { option: { specialties } } = yield select();
        yield put(optionActions.setOptionSpecialties(orderBy([...specialties, data], ['name'])));
    } catch (e) {
        const errors = e?.response?.data;
        if (!errors) return;
        const registrationError = {};
        availableLanguages.forEach(language => {
            if (errors[language])
                registrationError[language] = i18n.t('La especialidad ya fue creada');
        });
        yield put(optionActions.setOptionSpecialtiesRegistrationError(registrationError));
    } finally {
        yield put(optionActions.setOptionSpecialtiesLoading(false));
    }
}

function* _deleteControl ({ payload }) {
    try {
        yield put(optionActions.setOptionControlsLoading(true));
        yield call(optionServices.deleteControl, { id: payload });
        const { option: { controls } } = yield select();
        yield put(optionActions.setOptionControls(controls.filter(({ id }) => id !== payload)));
    } catch (e) {

    } finally {
        yield put(optionActions.setOptionControlsLoading(false));
    }
}

function* _deletePolyOffice ({ payload }) {
    try {
        yield put(optionActions.setOptionPolyOfficesLoading(true));
        yield call(optionServices.deletePolyOffice, { id: payload });
        const { option: { polyOffices } } = yield select();
        yield put(optionActions.setOptionPolyOffices(polyOffices.filter(({ id }) => id !== payload)));
    } catch (e) {

    } finally {
        yield put(optionActions.setOptionPolyOfficesLoading(false));
    }
}

function* _deleteSpecialty ({ payload }) {
    try {
        yield put(optionActions.setOptionSpecialtiesLoading(true));
        yield call(optionServices.deleteSpecialty, { id: payload });
        const { option: { specialties } } = yield select();
        yield put(optionActions.setOptionSpecialties(specialties.filter(({ id }) => id !== payload)));
    } catch (e) {

    } finally {
        yield put(optionActions.setOptionSpecialtiesLoading(false));
    }
}

function* _getCampaignTypes () {
    try {
        const { option: { campaignTypes } } = yield select();
        if (!isEmpty(campaignTypes)) return;
        yield put(optionActions.setOptionCampaignTypesLoading(true));
        const { data } = yield call(optionServices.fetchCampaignTypes);
        yield put(optionActions.setOptionCampaignTypes(orderBy(parseSelect(data), 'label')));
    } catch (e) {

    } finally {
        yield put(optionActions.setOptionCampaignTypesLoading(false));
    }
}

function* _getCities ({ payload }) {
    try {
        if (!payload) return;
        yield put(optionActions.setOptionCitiesLoading(true));
        const { data } = !payload ? { data: [] } : yield call(optionServices.getAllCities, { id: payload });
        yield put(optionActions.setOptionCities(parseSelect(data)));
    } catch (e) {
        
    } finally {
        yield put(optionActions.setOptionCitiesLoading(false));
    }
}

function* _getCompanies () {
    try {
        const { option: { companies } } = yield select();
        if (!isEmpty(companies)) return;
        yield put(optionActions.setOptionCompaniesLoading(true));
        const { data } = yield call(optionServices.fetchCompanies);
        yield put(optionActions.setOptionCompanies(parseSelect(data)));
    } catch (e) {

    } finally {
        yield put(optionActions.setOptionCompaniesLoading(false));
    }
}

function* _getControlTypes () {
    try {
        const { option: { controlTypes } } = yield select();
        if (!isEmpty(controlTypes)) return;
        yield put(optionActions.setOptionControlTypesLoading(true));
        const { data } = yield call(optionServices.fetchControlTypes);
        yield put(optionActions.setOptionControlTypes(parseSelect(data)));
    } catch (e) {

    } finally {
        yield put(optionActions.setOptionControlTypesLoading(false));
    }
}

function* _getControlTypesDetail () {
    try {
        const { option: { controlTypesDetail } } = yield select();
        if (!isEmpty(controlTypesDetail)) return;
        yield put(optionActions.setOptionControlTypesDetailLoading(true));
        const { data } = yield call(optionServices.fetchControlTypesDetail);
        yield put(optionActions.setOptionControlTypesDetail(data));
    } catch (e) {

    } finally {
        yield put(optionActions.setOptionControlTypesDetailLoading(false));
    }
}

function* _getControls () {
    try {
        const { option: { controls } } = yield select();
        if (!isEmpty(controls)) return;
        yield put(optionActions.setOptionControlsLoading(true));
        const { data } = yield call(optionServices.fetchControls);
        yield put(optionActions.setOptionControls(parseControls(data)));
    } catch (e) {

    } finally {
        yield put(optionActions.setOptionControlsLoading(false));
    }
}

function* _getCostCenters () {
    try {
        const { option: { costCenters } } = yield select();
        if (!isEmpty(costCenters)) return;
        yield put(optionActions.setOptionCostCentersLoading(true));
        const { data } = yield call(optionServices.fetchCostCenters);
        yield put(optionActions.setOptionCostCenters(parseSelect(data)));
    } catch (e) {

    } finally {
        yield put(optionActions.setOptionCostCentersLoading(false));
    }
}

function* _getCoverages () {
    try {
        const { option: { coverages } } = yield select();
        if (!isEmpty(coverages)) return;
        const { data } = yield call(optionServices.getAllCoverages);
        yield put(optionActions.setOptionCoverages(parseSelect(data, 'business_name')));
    } catch (e) {

    }
}

function* _getDistricts ({ payload }) {
    try {
        if (!payload) {
            yield put(optionActions.setOptionDistricts([]));
            return;
        }
        yield put(optionActions.setOptionDistrictsLoading(true));
        const { data } = !payload ? { data: [] } : yield call(optionServices.getAllDistricts, { id: payload });
        yield put(optionActions.setOptionDistricts(parseSelect(data)));
    } catch (e) {

    } finally {
        yield put(optionActions.setOptionDistrictsLoading(false));
    }
}

function* _getEnrollments () {
    try {
        const { option: { enrollments } } = yield select();
        if (!isEmpty(enrollments)) return;
        const { data } = yield call(optionServices.getAllEnrollments);
        yield put(optionActions.setOptionEnrollments(parseSelect(data)));
    } catch (e) {
        
    }
}

function* _getOffices ({ payload }) {
    try {
        const { data } = yield call(optionServices.getAllOffices, null, payload);
        yield put(optionActions.setOptionOffices(parseSelect(data)));
    } catch (e) {
        
    }
}

function* _getPatients ({ payload }) {
    try {
        const { minLength, search, ...params } = payload;
        if (!minLength || minLength <= search.length) {
            yield put(optionActions.setOptionPatientsLoading(true));
            const { data } = yield call(optionServices.getAllPatients, null, { ...params, search });
            yield put(optionActions.setOptionPatients(parsePatients(data)));
        }
    } catch (e) {

    } finally {
        yield put(optionActions.setOptionPatientsLoading(false));
    }
}

function* _getPlans ({ payload }) {
    try {
        if (!payload) return;
        const { data } = yield call(optionServices.fetchPlans, { coverage_id: payload });
        yield put(optionActions.setOptionPlans(parseSelect(data)));
    } catch (e) {

    }
}

function* _getPolyOffices ({ params }) {
    try {
        yield put(optionActions.setOptionPolyOfficesLoading(true));
        const { data } = yield call(optionServices.getAllPolyOffices, null, params);
        yield put(optionActions.setOptionPolyOffices(orderBy(parseSelect(data), 'name')));
    } catch (e) {

    } finally {
        yield put(optionActions.setOptionPolyOfficesLoading(false));
    }
}

function* _getPositions () {
    try {
        const { option: { positions } } = yield select();
        if (!isEmpty(positions)) return;
        yield put(optionActions.setOptionPositionsLoading(true));
        const { data } = yield call(optionServices.fetchPositions);
        yield put(optionActions.setOptionPositions(parseSelect(data)));
    } catch (e) {

    } finally {
        yield put(optionActions.setOptionPositionsLoading(false));
    }
}

function* _getProfessionals ({ payload }) {
    try {
        yield put(optionActions.setOptionProfessionalsLoading(true));
        const onlyAvailable = !!payload?.onlyAvailable;
        const callType = !!payload?.callType ? payload.callType : '';
        const specialtyId = !!payload?.specialtyId ? payload.specialtyId : 0;
        const params = {
            ...(callType && { call_type: callType }),
            ...(onlyAvailable && { available: 1 }),
            ...(specialtyId !== 0 && { specialty: specialtyId })
        };
        const { data } = yield call(optionServices.getAllProfessionals, null, params);
        yield put(optionActions.setOptionProfessionals(parseProfessionals(data)));
    } catch (e) {

    } finally {
        yield put(optionActions.setOptionProfessionalsLoading(false));
    }
}

function* _getProvinces () {
    try {
        const { option: { provinces } } = yield select();
        if (!isEmpty(provinces)) return;
        yield put(optionActions.setOptionProvincesLoading(true));
        const { data } = yield call(optionServices.getAllProvinces);
        yield put(optionActions.setOptionProvinces(parseSelect(data)));
    } catch (e) {

    } finally {
        yield put(optionActions.setOptionProvincesLoading(false));
    }
}

function* _getRiskAgent ({ payload }) {
    try {
        yield put(optionActions.setOptionRiskAgentsLoading(true));
        const { data } = yield call(optionServices.fetchRiskAgent, { id: payload });
        yield put(optionActions.setOptionRiskAgentsSelected(data));
    } catch (e) {

    } finally {
        yield put(optionActions.setOptionRiskAgentsLoading(false));
    }
}

function* _getRiskAgentTypes () {
    try {
        const { option: { riskAgentTypes } } = yield select();
        if (!isEmpty(riskAgentTypes)) return;
        yield put(optionActions.setOptionRiskAgentTypesLoading(true));
        const { data } = yield call(optionServices.fetchRiskAgentTypes);
        yield put(optionActions.setOptionRiskAgentTypes(parseSelect(data)));
    } catch (e) {
        
    } finally {
        yield put(optionActions.setOptionRiskAgentTypesLoading(false));
    }
}

function* _getRiskAgents () {
    try {
        const { option: { riskAgents } } = yield select();
        if (!isEmpty(riskAgents)) return;
        yield put(optionActions.setOptionRiskAgentsLoading(true));
        const { data } = yield call(optionServices.fetchRiskAgents);
        const parsedRiskAgents = orderBy(data.map(riskAgent => parseRiskAgent(riskAgent), 'name'));
        yield put(optionActions.setOptionRiskAgents(parsedRiskAgents));
    } catch (e) {

    } finally {
        yield put(optionActions.setOptionRiskAgentsLoading(false));
    }
}

function* _getSpecialties ({ payload }) {
    try {
        const { unparsed, ...params } = payload ?? {};
        yield put(optionActions.setOptionSpecialtiesLoading(true));
        const { data } = yield call(optionServices.fetchSpecialties, null, params);
        yield put(!unparsed ? optionActions.setOptionSpecialties(parseSpecialties(data)) : optionActions.setOptionSpecialties(data));
    } catch (e) {

    } finally {
        yield put(optionActions.setOptionSpecialtiesLoading(false));
    }
}

function* _getSymptoms () {
    try {
        const { option: { symptoms } } = yield select();
        if (!isEmpty(symptoms)) return;
        const { data } = yield call(optionServices.getAllSymptoms);
        yield put(optionActions.setOptionSymptoms(parseSelect(data)));
    } catch (e) {

    }
}

function* _getVaccineDoses ({ payload: id }) {
    try {
        yield put(optionActions.setOptionVaccineDosesLoading(true));
        const { data } = yield call(optionServices.fetchVaccineDoses, { id });
        const parsedDoses = (data?.doses ?? []).map(e => ({
            ...e,
            label: `${ e.number }${ !!e.days ? ` - ${ e.days } ${ i18n.t('días') }` : '' }`,
            value: e.id
        }));
        yield put(optionActions.setOptionVaccineDoses(parsedDoses));
    } catch (e) {

    } finally {
        yield put(optionActions.setOptionVaccineDosesLoading(false));
    }
}

function* _getVaccines () {
    try {
        const { option: { vaccines } } = yield select();
        if (!isEmpty(vaccines)) return;
        yield put(optionActions.setOptionVaccinesLoading(true));
        const { data } = yield call(optionServices.fetchVaccines);
        yield put(optionActions.setOptionVaccines(parseSelect(data)));
    } catch (e) {

    } finally {
        yield put(optionActions.setOptionVaccinesLoading(false));
    }
}

function* _getWorkplaces () {
    try {
        const { option: { workplaces } } = yield select();
        if (!isEmpty(workplaces)) return;
        yield put(optionActions.setOptionWorkplacesLoading(true));
        const { data } = yield call(optionServices.fetchWorkplaces);
        yield put(optionActions.setOptionWorkplaces(parseWorkplaces(data)));
    } catch (e) {

    } finally {
        yield put(optionActions.setOptionWorkplacesLoading(false));
    }
}

function* _getAreas () {
    try {
        const { option: { areas } } = yield select();
        if (!isEmpty(areas)) return;
        yield put(optionActions.setOptionAreasLoading(true));
        const { data } = yield call(optionServices.fetchAreas);
        yield put(optionActions.setOptionAreas(parseSelect(data)));
    } catch (e) {

    } finally {
        yield put(optionActions.setOptionAreasLoading(false));
    }
}

function* _updateCampaignType ({ payload: { id, ...payload } }) {
    try {
        yield put(optionActions.setOptionCampaignTypesLoading(true));
        yield call(optionServices.putCampaignType, { id }, payload);
        const { option: { campaignTypes } } = yield select();
        const oldType = campaignTypes.find(({ id: typeId }) => typeId === id);
        yield put(optionActions.setOptionCampaignTypes(orderBy([...campaignTypes.filter(({ id: typeId }) => typeId !== id), { ...oldType, ...payload }], 'label')));
    } catch (e) {

    } finally {
        yield put(optionActions.setOptionCampaignTypesLoading(false));
    }
}

function* _updatePolyOffice ({ payload: { id, ...payload } }) {
    try {
        yield put(optionActions.setOptionPolyOfficesLoading(true));
        const { data: updatedPolyOffice, data: { id: updateId } } = yield call(optionServices.putPolyOffice, { id }, payload);
        const { option: { polyOffices } } = yield select();
        yield put(optionActions.setOptionPolyOffices(orderBy([...polyOffices.filter(({ id }) => updateId !== id), updatedPolyOffice], 'name')));
    } catch (e) {

    } finally {
        yield put(optionActions.setOptionPolyOfficesLoading(false));
    }
}

function* _updateSpecialty ({ payload: { id, ...payload } }) {
    try {
        yield put(optionActions.setOptionSpecialtiesLoading(true));
        const { data } = yield call(optionServices.putSpecialty, { id }, payload);
        yield put(optionActions.setOptionSpecialtiesSuccess(true));
        const { option: { specialties } } = yield select();
        const newSpecialties = clone(specialties);
        newSpecialties[newSpecialties.findIndex(({ id: specId }) => specId === id)] = data;
        yield put(optionActions.setOptionSpecialties(orderBy(newSpecialties), 'name'));
    } catch (e) {
        const errors = e?.response?.data;
        if (!errors) return;
        const registrationError = {};
        availableLanguages.forEach(language => {
            if (errors[language])
                registrationError[language] = i18n.t('La especialidad ya fue creada');
        });
        yield put(optionActions.setOptionSpecialtiesRegistrationError(registrationError));
    } finally {
        yield put(optionActions.setOptionSpecialtiesLoading(false));
    }
}

function* _upsertArea ({ payload }) {
    try {
        const { id, ...body } = payload;
        yield put(optionActions.setOptionAreasError({}));
        yield put(optionActions.setOptionAreasStatus('loading'));
        const { option: { areas } } = yield select();
        const { data } = !id ? yield call(optionServices.postArea, null, body) : yield call(optionServices.putArea, { id }, body);
        if (id) {
            yield put(optionActions.setOptionAreas(replaceObjectArray(areas, data, 'id', id)));
        } else {
            yield put(optionActions.setOptionAreas([data, ...areas]));
        }
        yield put(optionActions.setOptionAreasStatus('done'));
    } catch (e) {
        const data = e?.response?.data;
        yield put(optionActions.setOptionAreasStatus(''));
        yield put(optionActions.setOptionAreasError({
            ...(data?.name && data?.name[0] === 'IS_ALREADY_TAKEN' && { name: i18n.t('Ya utilizado') })
        }));
    }
}

function* _upsertCompany ({ payload }) {
    try {
        const { id, ...body } = payload;
        yield put(optionActions.setOptionCompaniesError({}));
        yield put(optionActions.setOptionCompaniesStatus('loading'));
        const { option: { companies } } = yield select();
        const { data } = !id ? yield call(optionServices.postCompany, null, body) : yield call(optionServices.putCompany, { id }, body);
        if (id) {
            yield put(optionActions.setOptionCompanies(replaceObjectArray(companies, data, 'id', id)));
        } else {
            yield put(optionActions.setOptionCompanies([data, ...companies]));
        }
        yield put(optionActions.setOptionCompaniesStatus('done'));
    } catch (e) {
        const data = e?.response?.data;
        yield put(optionActions.setOptionCompaniesStatus(''));
        yield put(optionActions.setOptionCompaniesError({
            ...(data?.name && data?.name[0] === 'IS_ALREADY_TAKEN' && { name: i18n.t('Ya utilizado') })
        }));
    }
}

function* _upsertControl ({ payload }) {
    try {
        const { id, ...body } = payload;
        yield put(optionActions.setOptionControlsError({}));
        yield put(optionActions.setOptionControlsStatus('loading'));
        const { option: { controls } } = yield select();
        const { data } = !id ? yield call(optionServices.postControl, null, body) : yield call(optionServices.putControl, { id }, body);
        if (id) {
            yield put(optionActions.setOptionControls(replaceObjectArray(controls, parseControl(data), 'id', id)));
        } else {
            yield put(optionActions.setOptionControls([parseControl(data), ...controls]));
        }
        yield put(optionActions.setOptionControlsStatus('done'));
    } catch (e) {
        const data = e?.response?.data;
        yield put(optionActions.setOptionControlsStatus(''));
        yield put(optionActions.setOptionControlsError({
            ...(data?.name && data?.name[0] === 'IS_ALREADY_TAKEN' && { name: i18n.t('Ya utilizado') })
        }));
    }
}

function* _upsertCostCenter ({ payload }) {
    try {
        const { id, ...body } = payload;
        yield put(optionActions.setOptionCostCentersError({}));
        yield put(optionActions.setOptionCostCentersStatus('loading'));
        const { option: { costCenters } } = yield select();
        const { data } = !id ? yield call(optionServices.postCostCenter, null, body) : yield call(optionServices.putCostCenter, { id }, body);
        if (id) {
            yield put(optionActions.setOptionCostCenters(replaceObjectArray(costCenters, data, 'id', id)));
        } else {
            yield put(optionActions.setOptionCostCenters([data, ...costCenters]));
        }
        yield put(optionActions.setOptionCostCentersStatus('done'));
    } catch (e) {
        const data = e?.response?.data;
        yield put(optionActions.setOptionCostCentersStatus(''));
        yield put(optionActions.setOptionCostCentersError({
            ...(data?.name && data?.name[0] === 'IS_ALREADY_TAKEN' && { name: i18n.t('Ya utilizado') })
        }));
    }
}

function* _upsertPosition ({ payload }) {
    try {
        const { id, ...body } = payload;
        yield put(optionActions.setOptionPositionsError({}));
        yield put(optionActions.setOptionPositionsStatus('loading'));
        const { option: { positions } } = yield select();
        const { data } = !id ? yield call(optionServices.postPosition, null, body) : yield call(optionServices.putPosition, { id }, body);
        const newData = {
            ...data,
            label: data?.name,
            value: data?.id
        };
        if (id) {
            yield put(optionActions.setOptionPositions(replaceObjectArray(positions, newData, 'id', id)));
        } else {
            yield put(optionActions.setOptionPositions([newData, ...positions]));
        }
        yield put(optionActions.setOptionPositionsStatus('done'));
    } catch (e) {
        const data = e?.response?.data;
        yield put(optionActions.setOptionPositionsStatus(''));
        yield put(optionActions.setOptionPositionsError({
            ...(data?.name && data?.name[0] === 'IS_ALREADY_TAKEN' && { name: i18n.t('Ya utilizado') })
        }));
    }
}

function* _upsertRiskAgent ({ payload }) {
    try {
        const { id, ...body } = payload;
        yield put(optionActions.setOptionRiskAgentsError({}));
        yield put(optionActions.setOptionRiskAgentsLoading(true));
        if (!id) {
            yield call(optionServices.postRiskAgent, null, body);
        } else {
            yield call(optionServices.putRiskAgent, { id }, body);
        }
        yield put(optionActions.setOptionRiskAgents([]));
        yield put(push(i18n.t('/agentes')));
    } catch (e) {
        const data = e?.response?.data;
        yield put(optionActions.setOptionRiskAgentsError({
            ...(data?.name && data?.name[0] === 'IS_ALREADY_TAKEN' && { name: i18n.t('Ya utilizado') })
        }));
    } finally {
        yield put(optionActions.setOptionRiskAgentsLoading(false));
    }
}

function* _upsertWorkplace ({ payload }) {
    try {
        const { id, ...body } = payload;
        yield put(optionActions.setOptionWorkplacesError({}));
        yield put(optionActions.setOptionWorkplacesStatus('loading'));
        const { option: { workplaces } } = yield select();
        const { data } = !id ? yield call(optionServices.postWorkplace, null, body) : yield call(optionServices.putWorkplace, { id }, body);
        if (id) {
            yield put(optionActions.setOptionWorkplaces(replaceObjectArray(workplaces, data, 'id', id)));
        } else {
            yield put(optionActions.setOptionWorkplaces([data, ...workplaces]));
        }
        yield put(optionActions.setOptionWorkplacesStatus('done'));
    } catch (e) {
        const data = e?.response?.data;
        yield put(optionActions.setOptionWorkplacesStatus(''));
        yield put(optionActions.setOptionWorkplacesError({
            ...(data?.name && data?.name[0] === 'IS_ALREADY_TAKEN' && { name: i18n.t('Ya utilizado') })
        }));
    }
}

export default [
    takeEvery(optionActions.createPolyOffice.type, _createPolyOffice),
    takeEvery(optionActions.createSpecialty.type, _createSpecialty),
    takeEvery(optionActions.deleteControl.type, _deleteControl),
    takeEvery(optionActions.deletePolyOffice.type, _deletePolyOffice),
    takeEvery(optionActions.deleteSpecialty.type, _deleteSpecialty),
    takeEvery(optionActions.getAreas.type, _getAreas),
    takeEvery(optionActions.getCampaignTypes.type, _getCampaignTypes),
    takeEvery(optionActions.getCities.type, _getCities),
    takeEvery(optionActions.getCompanies.type, _getCompanies),
    takeEvery(optionActions.getControls.type, _getControls),
    takeEvery(optionActions.getControlTypes.type, _getControlTypes),
    takeEvery(optionActions.getControlTypesDetail.type, _getControlTypesDetail),
    takeEvery(optionActions.getCostCenters.type, _getCostCenters),
    takeEvery(optionActions.getCoverages.type, _getCoverages),
    takeEvery(optionActions.getDistricts.type, _getDistricts),
    takeEvery(optionActions.getEnrollments.type, _getEnrollments),
    takeEvery(optionActions.getOffices.type, _getOffices),
    takeEvery(optionActions.getPatients.type, _getPatients),
    takeEvery(optionActions.getPlans.type, _getPlans),
    takeEvery(optionActions.getPolyOffices.type, _getPolyOffices),
    takeEvery(optionActions.getPositions.type, _getPositions),
    takeEvery(optionActions.getProfessionals.type, _getProfessionals),
    takeEvery(optionActions.getProvinces.type, _getProvinces),
    takeEvery(optionActions.getRiskAgent.type, _getRiskAgent),
    takeEvery(optionActions.getRiskAgents.type, _getRiskAgents),
    takeEvery(optionActions.getRiskAgentTypes.type, _getRiskAgentTypes),
    takeEvery(optionActions.getSpecialties.type, _getSpecialties),
    takeEvery(optionActions.getSymptoms.type, _getSymptoms),
    takeEvery(optionActions.getVaccineDoses.type, _getVaccineDoses),
    takeEvery(optionActions.getVaccines.type, _getVaccines),
    takeEvery(optionActions.getWorkplaces.type, _getWorkplaces),
    takeEvery(optionActions.updateCampaignType.type, _updateCampaignType),
    takeEvery(optionActions.updatePolyOffice.type, _updatePolyOffice),
    takeEvery(optionActions.updateSpecialty.type, _updateSpecialty),
    takeEvery(optionActions.upsertArea.type, _upsertArea),
    takeEvery(optionActions.upsertCompany.type, _upsertCompany),
    takeEvery(optionActions.upsertControl.type, _upsertControl),
    takeEvery(optionActions.upsertCostCenter.type, _upsertCostCenter),
    takeEvery(optionActions.upsertPosition.type, _upsertPosition),
    takeEvery(optionActions.upsertRiskAgent.type, _upsertRiskAgent),
    takeEvery(optionActions.upsertWorkplace.type, _upsertWorkplace)
];
